/**
 * 상세 페이지 (vod, movie, live등)에서 공통사용되는 mixin
 * delegate를 통한 플레이어와의 통신 후처리
 * 그외 공통 기능
 * WARNING :: 플레이어 전용 페이지 stream
 * TODO :: 비사용로직 정리 필요
 */
export default {
  data() {
    return {
      shareLayout: false,
    }
  },
  methods: {
    replaceState(url) {
      this.$router.replace(url)
    },
    // 공유 레이어 팝업 닫기
    openShareLayout() {
      this.shareLayout = true
    },
    closeShareLayout() {
      this.shareLayout = false
    },
  },
}
